import { AlertType } from '../components/common/AlertMessage';

/**
 * 全局 Alert 事件名称
 */
const GLOBAL_ALERT_EVENT = 'global-alert';

/**
 * 全局 Alert 事件数据接口
 */
export interface GlobalAlertEventData {
  type: AlertType;
  message: string;
  closable?: boolean;
}

/**
 * 全局 Alert 工具类
 * 用于在非 React 组件环境中触发 Alert 提示
 */
class GlobalAlert {
  /**
   * 显示错误提示
   */
  showError(message: string): void {
    this.dispatchAlert('error', message);
  }

  /**
   * 显示成功提示
   */
  showSuccess(message: string): void {
    this.dispatchAlert('success', message);
  }

  /**
   * 显示警告提示
   */
  showWarning(message: string): void {
    this.dispatchAlert('warning', message);
  }

  /**
   * 显示信息提示
   */
  showInfo(message: string): void {
    this.dispatchAlert('info', message);
  }

  /**
   * 触发全局 Alert 事件
   */
  private dispatchAlert(type: AlertType, message: string, closable?: boolean): void {
    if (typeof window !== 'undefined') {
      const event = new CustomEvent<GlobalAlertEventData>(GLOBAL_ALERT_EVENT, {
        detail: {
          type,
          message,
          closable
        }
      });
      // 使用 setTimeout 确保事件在下一个事件循环中触发，避免同步问题
      setTimeout(() => {
        window.dispatchEvent(event);
      }, 0);
    }
  }
}

/**
 * 获取全局 Alert 事件名称（供监听器使用）
 */
export const getGlobalAlertEventName = (): string => GLOBAL_ALERT_EVENT;

/**
 * 导出全局 Alert 实例
 */
export const globalAlert = new GlobalAlert();

